export const MAX_TEXT_CUT_LENGTH = 20;

export const getTextCutByLength = (
  text: string,
  maxLength = MAX_TEXT_CUT_LENGTH
) => {
  return text.length > maxLength
    ? `${text.slice(0, maxLength - 3).trim()}...`
    : text;
};
